<template>
  <div class="mb-8 mt-6">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th
              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Location
            </th>
            <th
              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Rating
            </th>
            <th
              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Reviews
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr
            v-for="city in citiesData"
            :key="city.city + city.state"
            class="hover:bg-gray-50"
          >
            <td class="px-6 py-4 whitespace-nowrap">
              <NuxtLink
                :to="city.url"
                class="text-primary-700 hover:text-primary-900 underline"
              >
                {{ city.location_display || `${city.city}, ${city.state}` }}
              </NuxtLink>
            </td>
            <td class="px-6 py-4 whitespace-nowrap">
              <div class="flex items-center">
                <span class="mr-2 font-medium">{{ city.avg_rating }}</span>
                <RatingStars
                  class="text-primary"
                  :rating="city.avg_rating"
                  size="md"
                />
              </div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap">
              {{ city.reviews_count }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
interface CityData {
  city: string
  state: string
  state_full: string
  location_display?: string
  reviews_count: number
  avg_rating: number
  rating_distribution: Record<string, number>
  url: string
}
interface Props {
  citiesData: CityData[]
}
const props = defineProps<Props>()
</script>
